/**
 * Created by karora on 11/03/17.
 */
import 'rxjs/add/operator/switchMap';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { WebService } from '../services/web.service';
import { LeadDetails } from '../types/leads';
import { ActivatedRoute, Params } from '@angular/router';
import { Router } from '@angular/router';

import { ErrorStateMatcher } from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
  providers: [WebService],
})

export class SignUp implements OnInit {

  selectedFile: any = null;
  fuel: string = "gas";
  firstnameFormControl = new FormControl('', [Validators.required]);
  secondnameFormControl = new FormControl('', [Validators.required]);
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  eircodeFormControl = new FormControl('', [Validators.required]);
  countyFormControl = new FormControl('', [Validators.required]);
  mprnFormControl = new FormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]);
  berFormControl = new FormControl('');
  fuelFormControl = new FormControl('', [Validators.required]);
  gprnFormControl = new FormControl('');
  multizoneFormControl = new FormControl('', [Validators.required]);
  matcher = new MyErrorStateMatcher();

  leaddetails = new LeadDetails();
  errorMessage: string;

  constructor(
    private web: WebService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    try {
      this.route.params.subscribe((params: Params) => {
        this.web.getLeads(params['hash']).subscribe(
          (LeadDetails: any) => {
            this.leaddetails = LeadDetails[0]
            this.firstnameFormControl.setValue(this.leaddetails.first_name);
            this.secondnameFormControl.setValue(this.leaddetails.second_name);
            this.emailFormControl.setValue(this.leaddetails.email);
            this.fuelFormControl.setValue(this.leaddetails.fuel_type);
          },
          (error: any) => this.errorMessage = <any>error,
        );
      });
    } catch (e) {
      console.log('Error: ' + e);
    }
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  goToScreen(url: string): void {
    this.router.navigate(['/' + url]);
  }

  submit() {
    console.log("submit");
    if (this.firstnameFormControl.valid && this.secondnameFormControl.valid && this.emailFormControl.valid &&
      this.eircodeFormControl.valid && this.countyFormControl.valid && this.fuelFormControl.valid &&
      this.mprnFormControl.valid){
      this.leaddetails.first_name = this.firstnameFormControl.value;
      this.leaddetails.second_name = this.secondnameFormControl.value;
      this.leaddetails.email = this.emailFormControl.value;
      this.leaddetails.eircode = this.eircodeFormControl.value;
      this.leaddetails.county = this.countyFormControl.value;
      this.leaddetails.ber_rating = this.berFormControl.value;
      this.leaddetails.mprn = this.mprnFormControl.value;
      this.leaddetails.gprn = this.gprnFormControl.value;
      this.leaddetails.fuel_type = this.fuelFormControl.value;
      this.leaddetails.image = this.selectedFile;
      this.leaddetails.multi_zone = this.multizoneFormControl.value;
      this.web.submitSignUp(this.leaddetails).subscribe(
        (response) => {
          console.log("Success:      ");
          console.log(response);
          this.goToScreen("success");
        },
        (error) => {
          console.log("Fail:      ");
          console.log(error);
          this.goToScreen("fail")
        }
      );
    }
  }

  getRequiredErrorMessage() {
    return 'Required Field';
  }

  getMPRNRequiredErrorMessage() {
    return '11 Digit MPRN Required';
  }

  getBase64(event: any) {
    let that = this;
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async function () {
      that.selectedFile = await that.resizedataURL(reader.result, 800, 800);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  resizedataURL(datas: any, wantedWidth: any, wantedHeight: any){
    return new Promise(async function(resolve,reject){

        let img = document.createElement('img');

        img.onload = function()
        {        
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            canvas.width = wantedWidth;
            canvas.height = wantedHeight;
            ctx.drawImage(img, 0, 0, wantedWidth, wantedHeight);

            let dataURI = canvas.toDataURL();

            resolve(dataURI);
        };

        img.src = datas;

    })
  }
}
